import React, { useEffect, useState } from 'react';
import IncludeExcludeSelected from '../../components/IncludeExcludeSelected';
import { ReviewersSelectType } from '../../types';
import useGetRequest from '../../hooks/useGetRequest';
import { gameSteamIdFilter } from '@/pages/opinion/services';
import { steamIdFilterTips } from '../../../BubbleCommon';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function SteamIdSelect({
  gameInfo,
  params,
  collectionCallback,
  ...props
}: ReviewersSelectType) {
  const [timeParams, setTimeParams] = useState<
    | {
        start_time: string;
        end_time: string;
        date_type: string;
      }
    | undefined
  >(undefined);

  const {
    loading,
    basicOptions,
    clearOptions,
    debounceGetFilterList,
    setLoading,
    changeBasicOptions,
  } = useGetRequest({
    gameInfo,
    timeParams,
    params,
    singleKey: 'steam_id_content',
    multipleKey: 'steam_ids',
    requestFunc: gameSteamIdFilter,
  });

  useEffect(() => {
    collectionCallback?.('steamIds', (value: any) => setTimeParams(value), [
      'date',
    ]);
  }, []);

  return (
    <IncludeExcludeSelected
      changeBasicOptions={changeBasicOptions}
      clearOptions={clearOptions}
      loading={loading}
      setLoading={setLoading}
      basicOptions={basicOptions}
      getFilterList={debounceGetFilterList}
      maxShowNum={1}
      resultKey="steamId"
      includeKey="steam_ids"
      excludeKey="exclude_steam_ids"
      placeholderKey="steamIds"
      loadingText="The options provided by this filter are all lists of Steam ID within the selected time period. When the selected time period is long, you may need to wait a while for the complete list of publishers to load."
      placeholderText='Separate Multiple Steam ID With ",".'
      topTips="Please search and select the Steam ID"
      mainText="Steam ID"
      allFilterTips={steamIdFilterTips}
      {...props}
      pointKey={FilterButtonPoint.steamIds}
    ></IncludeExcludeSelected>
  );
}
